import React from "react";
import { Button } from "react-bootstrap";
import { TicketPreview } from "./TicketPreview";

export const TicketPreviewModal = ({ showTicketPreview, onClose, ticket }) => {
  if (!showTicketPreview) return null;

  return (
    <div className={`extraspace_search_div1 search_div${showTicketPreview ? " open" : ""}`}>
      <div className="ticket-preview-container bg-white p-4 rounded shadow-lg">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
          <h5 className="mb-0">Ticket Preview</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        <div className="modal-body">
          <TicketPreview ticket={ticket} />
        </div>
        <div className="modal-footer d-flex justify-content-end pt-3">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};
